export default "__VITE_ASSET__iJph34qs__"